import { useMutation } from '@tanstack/react-query';
import { getAuthorizedTradingUrl } from '../requests/authorizedTradingUrlRequest';
import type { TradingAuthorizeVariables } from '@/shared/types';

export function useAuthorizedTradingUrl() {
  const { mutate, mutateAsync, data, isPending, isError, error } = useMutation<
    Awaited<ReturnType<typeof getAuthorizedTradingUrl>>,
    Error,
    TradingAuthorizeVariables | void
  >({
    mutationKey: ['trading-authorize'],
    mutationFn: variables => {
      return getAuthorizedTradingUrl(variables ?? {});
    },
  });

  return {
    data,
    isPending,
    isError,
    error,
    mutate,
    getUrl: mutateAsync,
  };
}
